import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Resize item command
 *
 * @class ResizeItemCommand
 * @extends AbstractCommand
 */
export default class ResizeItemCommand extends AbstractCommand {
    constructor(item, width, height, position, rotation) {
        super();
        this.item = item;

        this.initialWidth = this.item.get('width');
        this.width = width !== undefined ? width : this.initialWidth;
        this.initialHeight = this.item.get('height');
        this.height = height !== undefined ? height : this.initialHeight;
        this.initialPosition = this.item.get('position').clone();
        this.position = position !== undefined ? position : this.initialPosition.clone();

        if (item.supportsRotation) {
            this.initialRotation = this.item.get('rotation');
            this.rotation = rotation !== undefined ? rotation : this.initialRotation;
        }
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return this.item.supportsHeight || this.item.supportsWidth;
    }

    /**
     * Set resize data
     *
     * @param {number} width
     * @param {number} height
     * @param {Point} position
     * @param {number} [rotation] Rotation of the item
     */
    setResizeData(width, height, position, rotation) {
        this.width = width;
        this.height = height;
        this.position = position;
        if (rotation !== undefined && this.item.supportsRotation) {
            this.rotation = rotation;
        }
    }

    /**
     * Execute command
     */
    execute() {
        const data = {
            width: this.width,
            height: this.height,
            position: this.position,
        };

        if (!this.isValid()) {
            return;
        }

        if (this.item.supportsRotation) {
            data.rotation = this.rotation;
        }

        this.item.set(data);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        const data = {
            width: this.initialWidth,
            height: this.initialHeight,
            position: this.initialPosition,
        };

        if (!this.isValid()) {
            return;
        }

        if (this.item.supportsRotation) {
            data.rotation = this.initialRotation;
        }

        this.item.set(data);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Resize ${this.item.attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.ResizeItemCommand = ResizeItemCommand;
